import { GameManager } from "../GameManager";
import { GameVars } from "../GameVars";
import { BackgroundContainer } from "./board/BackgroundContainer";
import { GameType } from "../Types";
import { GameOverMenu } from "./board/game-over-menu/GameOverMenu";
import type { GameOverMenuConfig } from "./board/game-over-menu/GameOverMenu";

export class DevScene extends Phaser.Scene {

    private backgroundContainer: BackgroundContainer;
    private componentsContainer: Phaser.GameObjects.Container;
    private gameOverMenu: GameOverMenu;
    private previewGameType: GameType.CHICAGO | GameType.RUBBER;

    constructor() {

        super("DevScene");
    }

    public init(data: { gameType?: GameType } = {}): void {

        this.previewGameType = data.gameType ?? GameType.RUBBER;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.backgroundContainer = new BackgroundContainer(this, false);
        this.add.existing(this.backgroundContainer);

        this.componentsContainer = new Phaser.GameObjects.Container(this);
        this.add.existing(this.componentsContainer);

        const chicagoConfig: GameOverMenuConfig = {
            gameType: GameType.CHICAGO,
            winningPartnership: "eastWest",
            scores: {
                northSouth: { totalPoints: 770, gamesWon: 3 },
                eastWest: { totalPoints: 860, gamesWon: 1 }
            },
            players: {
                0: { name: "James", avatarId: 1 },
                1: { name: "Manolo", avatarId: 2 },
                2: { name: "Sara", avatarId: 3 },
                3: { name: "Pablo", avatarId: 4 }
            },
            hands: [
                {
                    handNumber: 1,
                    dealer: 0,
                    contract: { level: 4, strain: 2, declarer: 0, doubled: false, redoubled: false },
                    declarerTricks: 12,
                    points: { northSouth: 620, eastWest: 0 },
                    winningPartnership: "northSouth"
                },
                {
                    handNumber: 2,
                    dealer: 1,
                    contract: { level: 3, strain: 3, declarer: 1, doubled: false, redoubled: false },
                    declarerTricks: 8,
                    points: { northSouth: 0, eastWest: 100 },
                    winningPartnership: "eastWest"
                },
                {
                    handNumber: 3,
                    dealer: 2,
                    contract: { level: 2, strain: 4, declarer: 2, doubled: false, redoubled: false },
                    declarerTricks: 9,
                    points: { northSouth: 150, eastWest: 0 },
                    winningPartnership: "northSouth"
                },
                {
                    handNumber: 4,
                    dealer: 3,
                    contract: { level: 6, strain: 3, declarer: 1, doubled: false, redoubled: false },
                    declarerTricks: 10,
                    points: { northSouth: 0, eastWest: 760 },
                    winningPartnership: "eastWest"
                }
            ]
        };
        const rubberConfig: GameOverMenuConfig = {
            gameType: GameType.RUBBER,
            winningPartnership: "northSouth",
            scores: {
                northSouth: { totalPoints: 740, gamesWon: 2 },
                eastWest: { totalPoints: 120, gamesWon: 1 }
            },
            players: {
                0: { name: "James", avatarId: 1 },
                1: { name: "Manolo", avatarId: 2 },
                2: { name: "Sara", avatarId: 3 },
                3: { name: "Pablo", avatarId: 4 }
            },
            games: [
                {
                    handCount: 6,
                    contractPoints: { northSouth: 130, eastWest: 0 },
                    points: { northSouth: 130, eastWest: 0 },
                    winningPartnership: "northSouth"
                },
                {
                    handCount: 7,
                    contractPoints: { northSouth: 0, eastWest: 120 },
                    points: { northSouth: 0, eastWest: 120 },
                    winningPartnership: "eastWest"
                },
                {
                    handCount: 5,
                    contractPoints: { northSouth: 110, eastWest: 0 },
                    points: { northSouth: 110, eastWest: 0 },
                    winningPartnership: "northSouth"
                }
            ]
        };

        this.gameOverMenu = new GameOverMenu(
            this, this.previewGameType === GameType.RUBBER ? rubberConfig : chicagoConfig
        );
        this.add.existing(this.gameOverMenu);
        this.relayout();
    }

    public relayout(): void {

        this.backgroundContainer.relayout();
        this.componentsContainer.setPosition(GameVars.gameWidth / 2, GameVars.gameHeight / 2);
        this.componentsContainer.scaleY = GameVars.scaleY;
        this.gameOverMenu.relayout();
    }
}
